import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "blushify_admin_token";

export const adminAxios = () => {
  const instance = axios.create({ baseURL: API, headers: { "x-admin-token": localStorage.getItem(TOKEN_KEY) } });
  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 401) {
        localStorage.removeItem(TOKEN_KEY);
        if (window.location.pathname.startsWith("/admin")) window.location.reload();
      }
      return Promise.reject(err);
    }
  );
  return instance;
};

export const adminLogin = (password, totp_code) => axios.post(`${API}/admin/login`, totp_code ? { password, totp_code } : { password });

export const enrollMfa = (setup_token) => axios.post(`${API}/admin/mfa/enroll`, { setup_token });

// prepend backend url for uploaded (relative) images
export const imgUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export { API, BACKEND_URL };
